// Types
import GenericContact from '@/types/generic-contact';
import Nullable from '@/types/nullable';
import User from '@/types/user';

// Utils
import { PERMISSIONS, userHasPermissionEnabled } from '@/utils/permissions';

export const isCanViewRiskProfile = (user?: Nullable<User>) =>
  !!user && userHasPermissionEnabled(user, PERMISSIONS.RISK_QUESTIONNAIRE, PERMISSIONS.RISK_PROFILE);

export const canViewPlanning = (user?: Nullable<User>, portfolioContact?: GenericContact) => {
  const hasPlanningPermission = !!user && userHasPermissionEnabled(user, PERMISSIONS.PLANNING);
  const isInContactContext = !!portfolioContact;

  return hasPlanningPermission && isInContactContext;
};
